import { Box, Paper, Skeleton, Stack, Typography } from '@mui/material';

const PermissionsSkeleton: React.FC = () => {
  return (
    <Paper
      elevation={0}
      sx={{ border: '1px solid #E0E0E0', p: 3 }}
    >
      <Stack spacing={2}>
        <Typography variant='h6'>
          <Skeleton width={150} />
        </Typography>

        {/* Advisor List Skeleton */}
        {[...Array(4)].map((_, index) => (
          <Box
            key={`advisor-${index}`}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 1,
              borderBottom: '1px solid rgba(224, 224, 224, 0.2)',
            }}
          >
            <Box
              sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}
            >
              <Skeleton
                variant='circular'
                width={32}
                height={32}
              />
              <Box sx={{ flex: 1 }}>
                <Skeleton width={150} />
                <Skeleton width={100} />
              </Box>
            </Box>
            <Skeleton
              variant='rounded'
              width={58}
              height={38}
            />
          </Box>
        ))}
      </Stack>
    </Paper>
  );
};

export default PermissionsSkeleton;
